var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdminPremissionUsername = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5222D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 11.75H29.75C30.1648 11.75 30.5 12.0852 30.5 12.5V27.5C30.5 27.9148 30.1648 28.25 29.75 28.25H10.25C9.83516 28.25 9.5 27.9148 9.5 27.5V12.5C9.5 12.0852 9.83516 11.75 10.25 11.75ZM28.8125 13.4375H11.1875V16.25H28.8125V13.4375ZM11.1875 26.5625H28.8125V18.3125H11.1875V26.5625ZM16.7422 25.0625H12.875C12.7719 25.0625 12.6875 24.9781 12.6875 24.875V23.1875C12.6875 23.0844 12.7719 23 12.875 23H16.7422C16.8453 23 16.9297 23.0844 16.9297 23.1875V24.875C16.9297 24.9781 16.8453 25.0625 16.7422 25.0625Z",
    fill: "#F5222D"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdminPremissionUsername, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AdminPremissionUsername.816ad0bf.svg";
export { ForwardRef as ReactComponent };